import files from "../files/index";

const path = '/takenaka';

const takenaka = (url: string) => () => ({
  files: files(url + path)
})

export default takenaka;